import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'

import CircularProgress from '@mui/material/CircularProgress'

import { useAuth } from 'hooks/useAuth'
import useQuery from 'hooks/useQuery'

export default function SsoAuth() {
  const { replace } = useHistory()
  const { signInWithSsoToken } = useAuth()
  const query = useQuery()

  useEffect(() => {
    const token = query.token
    const redirect = query.redirect ? decodeURIComponent(query.redirect) : '/'

    if (!token) {
      replace('/login')
      return
    }

    signInWithSsoToken(token, redirect).catch(error => {
      console.error('SSO verification failed:', error)
      replace('/login')
    })
    // マウント時1回だけ実行する。deps に signInWithSsoToken を入れると
    // axios interceptor → 再レンダ → callback 再生成 で無限ループになる。
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '60vh',
      }}
    >
      <CircularProgress />
    </div>
  )
}
